'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.concat')
require('core-js/modules/es.array.filter')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.includes')
require('core-js/modules/es.object.keys')
require('core-js/modules/es.string.includes')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _assertThisInitialized2 = _interopRequireDefault(
  require('@babel/runtime/helpers/assertThisInitialized')
)
var _inheritsLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/inheritsLoose'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _EventEmitter2 = _interopRequireDefault(require('../EventEmitter'))
var _obj = require('../obj')
var _is = require('../is')

var _Adapter = _interopRequireDefault(require('./Adapter'))
var StorageAdapterWithEvents = /*#__PURE__*/ (function(_EventEmitter) {
  ;(0, _inheritsLoose2.default)(StorageAdapterWithEvents, _EventEmitter)

  function StorageAdapterWithEvents(arg) {
    var _this
    _this = _EventEmitter.call(this) || this
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), 'adapter', void 0)
    _this.adapter = new _Adapter.default(arg)
    return _this
  }
  var _proto = StorageAdapterWithEvents.prototype
  _proto.getItem = function getItem() {
    return this.adapter.getItem()
  }
  _proto.setItem = function setItem(val) {
    this.adapter.setItem(val)

    if ((0, _is.isObj)(val)) {
      this._calcChangedAndEmit(val, true)
    }
    this._emitChange()
  }
  _proto.removeItem = function removeItem() {
    this.adapter.removeItem()
    this._calcChangedAndEmit({}, true)
    this._emitChange()
  }
  _proto.getProp = function getProp(propName) {
    return this.adapter.getProp(propName)
  }
  _proto.setProp = function setProp(propName, val) {
    var _this$_calcChangedAnd
    this.adapter.setProp(propName, val)
    this._calcChangedAndEmit(
      ((_this$_calcChangedAnd = {}), (_this$_calcChangedAnd[propName] = val), _this$_calcChangedAnd),
      false
    )
    this._emitChange()
  }
  _proto.setProps = function setProps(newProps) {
    this.adapter.setProps(newProps)
    this._calcChangedAndEmit(newProps, false)
    this._emitChange()
  }
  _proto.removeProp = function removeProp(propName) {
    var _this$_calcChangedAnd2
    this.adapter.removeProp(propName)
    this._calcChangedAndEmit(
      ((_this$_calcChangedAnd2 = {}),
      (_this$_calcChangedAnd2[propName] = undefined),
      _this$_calcChangedAnd2),
      false
    )
    this._emitChange()
  }
  _proto.removeProps = function removeProps(propNames) {
    this.adapter.removeProps(propNames)

    var emptyProps = {}
    propNames.forEach(function(propName) {
      emptyProps[propName] = undefined
    })

    this._calcChangedAndEmit(emptyProps, false)
    this._emitChange()
  }
  _proto._emitChange = function _emitChange() {
    this.emit('change', { adapter: this.adapter })
  }
  _proto._calcChangedAndEmit = function _calcChangedAndEmit(newItem, isReplacing) {
    var _this2 = this
    var oldItemResult = this.adapter.getItem()
    var oldItem = (0, _obj.castObj)(oldItemResult.value)

    var newItemPropNames = Object.keys(newItem)
    var oldItemPropNames = Object.keys(oldItem)

    var propsToRemove = !isReplacing
      ? []
      : oldItemPropNames.filter(function(propName) {
          return !newItemPropNames.includes(propName)
        })

    newItemPropNames.concat(propsToRemove).forEach(function(propName) {
      _this2.emit('change:' + propName, {
        value: newItem[propName],
        oldValue: oldItem[propName],
        adapter: _this2.adapter
      })
    })
  }
  _proto.destroy = function destroy() {
    this.off()
    delete this.adapter
  }
  return StorageAdapterWithEvents
})(_EventEmitter2.default)
exports.default = StorageAdapterWithEvents



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Storages/AdapterWithEvents.js
// module id = 307
// module chunks = 0